var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tribe-box-form" },
    [
      _c(
        "el-form",
        {
          attrs: {
            loading: _vm.loading,
            success: _vm.success,
            error: _vm.server_error,
            submitText: "Vraag een offerte aan"
          },
          on: { submit: _vm.submit }
        },
        [
          _c("p", { staticClass: "mb-16" }, [_vm._v("Tribe Box")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mb-24" },
            [
              _c("el-input", {
                staticClass: "col-12 col-md-6",
                attrs: {
                  type: "number",
                  label: "Aantal",
                  placeholder: "Aantal..",
                  rules: "required"
                },
                model: {
                  value: _vm.data.amount,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "amount", $$v)
                  },
                  expression: "data.amount"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "mb-16" }, [_vm._v("Contactgegevens")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mb-24" },
            [
              _c("el-input", {
                staticClass: "col-12 col-md-6",
                attrs: { label: "Voornaam", rules: "required" },
                model: {
                  value: _vm.data.first_name,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "first_name", $$v)
                  },
                  expression: "data.first_name"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 col-md-6",
                attrs: { label: "Achternaam", rules: "required" },
                model: {
                  value: _vm.data.last_name,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "last_name", $$v)
                  },
                  expression: "data.last_name"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 col-md-6",
                attrs: {
                  type: "email",
                  label: "E-mailadres",
                  rules: "required|email"
                },
                model: {
                  value: _vm.data.email,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "email", $$v)
                  },
                  expression: "data.email"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 col-md-6",
                attrs: { label: "Telefoonnummer", rules: "required" },
                model: {
                  value: _vm.data.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "phone", $$v)
                  },
                  expression: "data.phone"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 col-md-6",
                attrs: {
                  name: "btw-nummer",
                  label: "BTW nummer",
                  rules: "required"
                },
                model: {
                  value: _vm.data.vat,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "vat", $$v)
                  },
                  expression: "data.vat"
                }
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "col-12 col-md-6",
                attrs: { label: "Bedrijfsnaam", rules: "required" },
                model: {
                  value: _vm.data.company,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "company", $$v)
                  },
                  expression: "data.company"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "mb-8" }, [_vm._v("Opmerkingen")]),
          _vm._v(" "),
          _c("p", { staticClass: "small font-weight-light mb-16" }, [
            _vm._v(
              "Wil je nog een bericht of speciale wensen (personalisatie, verpakking, verzending, ...) toevoegen aan je aanvraag?"
            )
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: { type: "textarea", label: "Bericht" },
            model: {
              value: _vm.data.message,
              callback: function($$v) {
                _vm.$set(_vm.data, "message", $$v)
              },
              expression: "data.message"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("success-popover", {
        class: { active: _vm.success },
        attrs: {
          title: _vm.copyConfig.order_confirmation.title,
          description: _vm.copyConfig.order_confirmation.description,
          cta: _vm.copyConfig.order_confirmation.cta
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }